var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.ContentMixin_ElementHasPocoStatus('new'))?_c('v-list-item',{staticClass:"v-menu-list-item",on:{"click":function($event){return _vm.Duplicate()}}},[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.TextMixin_GetLabel('duplicate'))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }